import { fetchShow } from "../../../action_managers/shows";
import { getMediaFile, uploadToYoutube } from "../../../action_managers/shows";
import { EPISODE_DELETE_MODAL, CONFIRMATION_MODAL } from "../../modals/modal_root";
import { showModal } from "../../../actions/modal";
import { episodeDeleteClear } from "../../../actions/episode_delete_modal";
import EpisodePage from "./episode_page";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import messageType from "../../../constants/message_types";
import { showMessageWithTimeout } from "../../../actions/app";
import { getEpisode } from "../../../actions/episodes";
import { getScheduledJob } from "../../../action_managers/scheduled_job";

function mapStateToProps(state) {
  var props = {
    user: state.user.user,
    episodesByShow: state.episodesByShow,
    episodes: state.episodes,
    mediaFiles: state.mediaFiles,
    shows: state.shows,
    scheduledJobs: state.scheduledJobs.scheduledJobs,
  };
  return props;
}

const mapDispatchToProps = {
  getEpisode,
  fetchMediaFile: getMediaFile,
  showSuccess: message => showMessageWithTimeout(message, messageType.Success),
  fetchShow,
  showEpisodeDeleteModal: (showUUID, episodeUUID) =>
    showModal(EPISODE_DELETE_MODAL, {
      episodeUUID: episodeUUID,
      showUUID: showUUID,
    }),
  episodeDeleteModalReset: () => episodeDeleteClear(),
  publishToYoutubeConfirmation: callback =>
    showModal(CONFIRMATION_MODAL, {
      modalTitle: "Publish To Youtube?",
      confirmationMessage:
        "Your video will be uploaded to youtube within 1 hour. Please check back for the link.",
      callback,
    }),
  uploadToYoutube,
  getScheduledJob,
};

const EpisodePageWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(EpisodePage));

export default EpisodePageWrapper;
